import JobAssignmentList from './pages/ListPage.vue'
import JobAssignmentDetail from './pages/FormPage.vue'
import JobAssignmentIndex from './pages/IndexPage.vue'

export default [
    {
        path: '/job_assignment',
        component: JobAssignmentIndex,
        redirect: '/job_assignment/list',
        name: 'job_assignment',
        children: [
            {
                path: 'list',
                component: JobAssignmentList,
                name: 'job_assignment.list'
            },
            {
                path: 'create',
                component: JobAssignmentDetail,
                name: 'job_assignment.create',
                props: { create: true },
            },
            {
                path: 'edit/:id',
                component: JobAssignmentDetail,
                name: 'job_assignment.edit',
                props: { create: false },
            },
        ],
    },
]